<ng-container *ngIf="showTitle === true">
  <div class="mb-4 text-center text-md-start text-lg-start" *ngIf="!title">
    <h5 class="card-title mb-4">
      {{ getTranslationKey("title") | msg | async }}
    </h5>
  </div>
  <div class="mb-4 text-start text-md-start text-lg-start" *ngIf="title">
    <h5 class="card-title mb-4">{{ title | msg | async }}</h5>
  </div>
</ng-container>
<form [formGroup]="formGroup!">
  <div class="row">
    <div *ngFor="let row of inputs" class="mb-3" [ngClass]="row.columnClass">
      <app-input-container [label]="row.label ? getTranslationKey(row.label) : ''" [for]="row.name"
        [validationMessages]="
          getValidationMessages((formGroup?.controls)![row.name])!
        " [isRequired]="row.isRequired!" [popoverInfo]="row.popoverInfo"
        [expandableInfo]="row.expandableInfo">
        <ng-container [ngSwitch]="row.type">
          <input *ngSwitchDefault class="form-control shadow-none" type="text" name="{{ row.name }}"
            placeholder="{{ row.placeholder | msg | async }}" formControlName="{{ row.name }}"
            (input)="checkFunction(row?.onValueChange, $event)" />

          <input *ngSwitchCase="inputType.Password" class="form-control shadow-none" type="password"
            name="{{ row.name }}" placeholder="{{ row.placeholder | msg | async }}" formControlName="{{ row.name }}"
            (input)="checkFunction(row?.onValueChange, $event)" />

          <app-textarea *ngSwitchCase="inputType.Textarea" [placeholder]="row.placeholder" [name]="row.name"
            [controlName]="row.name" (valueChange)="emitValue($event)"></app-textarea>
          <div class="input-group append" *ngSwitchCase="inputType.Money">
            <input class="form-control shadow-none" type="text" name="{{ row.name }}" formControlName="{{ row.name }}"
              value="{{ row.value | curr }}" appNumberFormatter
              (beforeinput)="checkFunction(row?.onBeforeInput, $event)"
              (input)="checkFunction(row?.onValueChange, $event)" />
            <span class="input-group-append currency">CHF</span>
          </div>
          <input *ngSwitchCase="inputType.Number" class="form-control shadow-none" type="number" name="{{ row.name }}"
            formControlName="{{ row.name }}" (input)="checkFunction(row?.onValueChange, $event)" />

          <app-phone-input *ngSwitchCase="inputType.PhoneNumber" [controlName]="row.name"
            [valid]="validateControl((formGroup?.controls)![row.name])" [readonly]="row.readOnly ? row.readOnly : false"
            class="float-form-group" (phoneNumberChange)="checkFunction(row?.onValueChange, $event)"></app-phone-input>

          <app-input-group *ngSwitchCase="inputType.InputGroup" [placeholder]="row.placeholder" [name]="row.name"
            [controlName]="row.name" [icon]="row.inputGroupIcon" [text]="row.inputGroupText"
            [inputGroupType]="row.inputGroupType"></app-input-group>

          <app-datepicker *ngSwitchCase="inputType.Date" [value]="(formGroup?.controls)![row.name].value"
            [controlName]="row.name" [valid]="validateControl((formGroup?.controls)![row.name])"
            [readonly]="row.readOnly ? row.readOnly : false" [noDays]="row.noDays ? row.noDays : false"
            [maxDate]="getMaxDate(row.max)" [minDate]="getMinDate(row.min)" class="float-form-group"
            (onDateChange)="row?.onValueChange($event)">
          </app-datepicker>

          <app-select *ngSwitchCase="inputType.Select" [name]="row.name" [controlName]="row.name"
            [selectList]="row.selectValues" [strictValueKey]="row.strictValueKey"
            (valueChange)="row?.onValueChange($event)"></app-select>

          <app-radio-button *ngSwitchCase="inputType.Radio" [strictValueKey]="row.strictValueKey" [name]="row.name"
            [controlName]="row.name" [inline]="row.inline ? row.inline : false"
            (valueChange)="row?.onValueChange($event)"></app-radio-button>

          <app-switch-button *ngSwitchCase="inputType.SwitchButton" [strictValueKey]="row.strictValueKey"
            [value]="row.value" (valueChange)="checkFunction(row?.onValueChange, $event)"></app-switch-button>

          <app-switch-button-with-description *ngSwitchCase="inputType.SwitchButtonWithDescription" [prefix]="prefix"
            [strictValueKey]="row.strictValueKey" [value]="row.value"
            (valueChange)="checkFunction(row?.onValueChange, $event)"></app-switch-button-with-description>
          <p *ngSwitchCase="inputType.Info">
            {{ row.value | msg | async }}
          </p>
        </ng-container>
      </app-input-container>
    </div>
  </div>
</form>

<div class="row mt-4" *ngIf="showButtons">
  <app-submit-button-group (submitEvent)="submitButtonClicked()" (cancelEvent)="cancelButton()" [isLoading]="isLoading"
    [submitButtonText]="submitButtonText" [cancelButtonText]="cancelButtonText"></app-submit-button-group>
</div>
